var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 0H2.06251C0.925174 0 0 0.897137 0 2.00001V14C0 15.1029 0.925174 16 2.06251 16H19.9375C21.0748 16 22 15.1029 22 14V2.00001C22 0.897137 21.0748 0 19.9375 0ZM19.9375 1.33333C20.0309 1.33333 20.1198 1.35212 20.201 1.38494L11 9.11784L1.79896 1.38494C1.8802 1.35216 1.96906 1.33333 2.06247 1.33333H19.9375ZM19.9375 14.6666H2.06251C1.68319 14.6666 1.37499 14.3678 1.37499 13.9999V2.79361L10.5495 10.5039C10.6791 10.6126 10.8395 10.6667 11 10.6667C11.1605 10.6667 11.3209 10.6126 11.4505 10.5039L20.625 2.79361V14C20.625 14.3678 20.3168 14.6666 19.9375 14.6666Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8094061b.svg";
export { ForwardRef as ReactComponent };